import type { OpenQuoteWithSubTopic } from '../../../../types';
import PendingQuoteRow from '../PendingQuoteRow/PendingQuoteRow';
import { useOpenQuoteItem } from './useOpenQuoteItem';

type Props = {
  quote: OpenQuoteWithSubTopic;
};

export default function OpenQuoteItem(props: Props) {
  const hook = useOpenQuoteItem(props);

  return <PendingQuoteRow row={hook.row} href={hook.targetUrl} onClick={hook.handleClick} />;
}
